import React, { Component } from 'react';
import { InputForm } from './InputForm';
import { Result } from './Result';

export class ManualCalculation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rowData: null,
            loading: false,
            error: false,
            oldYear: null,
            newYear: null,
            vehicleCategory: null
        };
    }

    handleSubmit = values => {
        this.getCalculation(values);
    }

    async getCalculation(values) {
        this.setState({
            loading: true,
            error: false,
            vehicleCategory: values.vehicleCategory
        });

        await fetch('api/AnnualDiff/Definition')
            .then(response => { return response.json(); })
            .then(data => {
                this.setState({
                    oldYear: data.oldYear,
                    newYear: data.newYear
                });
            });

        const oldData = await this.getTaxesForYear(this.state.oldYear, values.vehicleCategory, values.weight, values.co2, values.nox, values.fuel, values.range);
        const newData = await this.getTaxesForYear(this.state.newYear, values.vehicleCategory, values.weight, values.co2, values.nox, values.fuel, values.range);

        if (oldData && newData) {
            const oldWeightNode = oldData.find(x => x.Heading === "Avgift for egenvekt");
            const oldCo2Node = oldData.find(x => x.Heading === "Avgift for CO2");
            const oldNoxNode = oldData.find(x => x.Heading === "Avgift for NOx");
            const newWeightNode = newData.find(x => x.Heading === "Avgift for egenvekt");
            const newCo2Node = newData.find(x => x.Heading === "Avgift for CO2");
            const newNoxNode = newData.find(x => x.Heading === "Avgift for NOx");

            const oldWeightTax = oldWeightNode ? parseFloat(oldWeightNode.Sum) : 0;
            const oldCo2Tax = oldCo2Node ? parseFloat(oldCo2Node.Sum) : 0;
            const oldNoxTax = oldNoxNode ? parseFloat(oldNoxNode.Sum) : 0;
            const newWeightTax = newWeightNode ? parseFloat(newWeightNode.Sum) : 0;
            const newCo2Tax = newCo2Node ? parseFloat(newCo2Node.Sum) : 0;
            const newNoxTax = newNoxNode ? parseFloat(newNoxNode.Sum) : 0;

            this.setState({
                rowData: [
                    {
                        component: 'Egenvekt',
                        oldPrice: oldWeightTax,
                        newPrice: newWeightTax,
                        priceDiff: newWeightTax - oldWeightTax
                    },
                    {
                        component: 'CO2',
                        oldPrice: oldCo2Tax,
                        newPrice: newCo2Tax,
                        priceDiff: newCo2Tax - oldCo2Tax
                    },
                    {
                        component: 'NOx',
                        oldPrice: oldNoxTax,
                        newPrice: newNoxTax,
                        priceDiff: newNoxTax - oldNoxTax
                    },
                    {
                        component: 'Sum engangsavgifter',
                        oldPrice: (oldWeightTax + oldCo2Tax + oldNoxTax > 0 ? parseInt(oldWeightTax + oldCo2Tax + oldNoxTax) : 0),
                        newPrice: (newWeightTax + newCo2Tax + newNoxTax > 0 ? parseInt(newWeightTax + newCo2Tax + newNoxTax) : 0),
                        priceDiff: (newWeightTax + newCo2Tax + newNoxTax > 0 ? parseInt(newWeightTax + newCo2Tax + newNoxTax) : 0) - (oldWeightTax + oldCo2Tax + oldNoxTax > 0 ? parseInt(oldWeightTax + oldCo2Tax + oldNoxTax) : 0),
                        bold: true
                    }
                ],
                loading: false,
                error: false
            });
        }
        else {
            this.setState({
                rowData: [],
                loading: false,
                error: true
            });
        }
    }

    async getTaxesForYear(year, vehicleCategory, weight, co2, nox, fuel, range) {
        return await fetch('api/ManualCalculation/Taxes',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: `{
                    "vehicleGroup":"${vehicleCategory}",
                    "date":"${year}-${new Date().getMonth() + 1}-${new Date().getDate()}",
                    "weight":"${weight}",
                    "power":"0",
                    "co2":"${co2}",
                    "nox":"${nox}",
                    "fuel":"${fuel}",
                    "batteryRange":"${range}"
                }`
            })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    return result.data.Details[0].Details;
                }
                else {
                    return null;
                }
            })
            .catch((error) => {
                return null;
            });
    }

    render() {
        return (
            <div style={{ padding: '10px' }}>
                <InputForm
                    onSubmit={this.handleSubmit}
                    loading={this.state.loading} />
                {this.state.rowData &&
                    <div style={{ paddingTop: '15px' }}>
                        <Result
                            rowData={this.state.rowData}
                            loading={this.state.loading}
                            error={this.state.error}
                            oldYear={this.state.oldYear}
                            newYear={this.state.newYear}
                            vehicleCategory={this.state.vehicleCategory} />
                    </div>
                }
            </div>
        );
    }
}
